<template>
  <BaseDialog
    :value="isVisible"
    @input="handleInput"
    :title="`Delete ${contentType.charAt(0).toUpperCase() + contentType.slice(1)}`"
    confirmLabel="Delete"
    confirmButtonClass="base-dialog__negative-btn"
    :loading="isDeleting"
    @confirm="handleConfirm"
    @hide="handleHide"
  >
    <div class="warning-box">
      <q-icon name="warning" color="negative" class="warning-icon" />
      <div class="warning-text">This will permanently delete the selected content.</div>
    </div>

    <p class="confirmation-text">Do you want to delete {{ contentCount }} {{ contentType }}? This action cannot be undone.</p>
  </BaseDialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BaseDialog from '@components/base/BaseDialog.vue';

export default {
  name: 'DeleteConfirmationDialog',
  components: {
    BaseDialog
  },
  computed: {
    ...mapGetters('deleteConfirmation', ['isVisible', 'contentCount', 'contentType', 'isDeleting'])
  },
  methods: {
    ...mapActions('deleteConfirmation', ['confirmDelete', 'cancelDelete', 'hideDeleteConfirmation']),

    handleConfirm() {
      this.confirmDelete();
    },

    handleHide() {
      this.cancelDelete();
    },

    handleInput(value) {
      if (!value) {
        this.hideDeleteConfirmation();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.warning-box {
  display: flex;
  align-items: center;
  background-color: rgba(255, 0, 0, 0.04);
  padding: 16px;
  border-radius: 10px;
  border-left: 4px solid #f44336;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.1);
}

.warning-icon {
  font-size: 24px;
  margin-right: 12px;
  color: var(--negative);
}

.warning-text {
  @include mona-sans-font($size: 15px, $bolded: true, $color: var(--danger));
}

.confirmation-text {
  @include inter-font($size: 15px, $color: var(--main-text-color));
  margin: 20px 0;
  line-height: 1.6;
}
</style>
